{
  "familyId": "REK-TAFELS-TOEPASSEN",
  "questions": [
    {
      "id": "REK-TAFELS-TOEPASSEN-001",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Je speelt een game en verdient elke ronde 8 punten. Na 7 rondes wil je weten hoeveel punten je hebt. Hoeveel is dat?",
      "options": ["56", "48", "64", "54"],
      "correctAnswer": 0,
      "conceptId": "tafels_context_gaming",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "context": "Gaming",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald optellen = vermenigvuldigen",
            "content": "Elke ronde 8 punten, 7 rondes lang. Dat is 7 × 8 = 56. Truc: 7 × 8 = 56 — de cijfers 5, 6, 7, 8 staan op volgorde!",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (6×8)", "optionIndex": 1 },
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (8×8)", "optionIndex": 2 },
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (6×9)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "7 rondes × 8 punten per ronde = 7 × 8 = 56 punten. Bij 'elke ronde' of 'per stuk' vermenigvuldig je. Onthoud: 5-6-7-8 → het antwoord is 56!",
        "solutionSteps": [
          "Stap 1: Lees — 7 rondes, 8 punten per ronde",
          "Stap 2: Bewerking — 7 × 8",
          "Check: 7 × 8 = 56 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 × 8 = 56 punten na 7 rondes.",
          "1": "Je dacht waarschijnlijk aan 6 × 8 = 48. Maar je speelt 7 rondes, niet 6. Lees het aantal rondes goed.",
          "2": "Je dacht waarschijnlijk aan 8 × 8 = 64. Maar je speelt 7 rondes, niet 8. Onthoud: 7 × 8 = 56.",
          "3": "Je dacht waarschijnlijk aan 6 × 9 = 54. Maar het is 7 rondes van 8 punten. Onthoud: 7 × 8 = 56."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-002",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "fill_in",
      "question": "Op een voetbaltoernooi doen 9 teams mee. Elk team heeft 6 spelers. Hoeveel spelers doen er in totaal mee?",
      "options": [],
      "correctAnswer": "54",
      "data": {
        "acceptedAnswers": ["54"]
      },
      "conceptId": "tafels_context_sport",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.70,
      "context": "Voetbaltoernooi",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aantal teams × spelers per team",
            "content": "9 teams van 6 spelers = 9 × 6 = 54. Truc: 9 × 6 = 10 × 6 − 6 = 60 − 6 = 54.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "9 teams × 6 spelers = 9 × 6 = 54 spelers. Truc: 9 × 6 = 10 × 6 − 6 = 60 − 6 = 54. Bij 'elk team heeft' vermenigvuldig je het aantal teams met het aantal per team.",
        "solutionSteps": [
          "Stap 1: 9 teams, 6 spelers per team",
          "Stap 2: 9 × 6 = 54",
          "Check: 10 × 6 − 6 = 60 − 6 = 54 ✓"
        ]
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-003",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "step_solver",
      "question": "Je koopt 4 pakjes stickers. In elk pakje zitten 8 stickers. Je geeft 5 stickers aan je vriendin. Hoeveel stickers heb je nog?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "prompt": "Hoeveel stickers koop je in totaal? (4 pakjes × 8 stickers)", "correctAnswer": "32", "hint": "Gebruik de tafel van 4 of 8 om het totaal te berekenen.", "explanation": "4 × 8 = 32 stickers" },
          { "prompt": "Je geeft 5 stickers weg. Hoeveel heb je nog? (32 − 5)", "correctAnswer": "27", "hint": "Weggeven betekent aftrekken. Trek 5 af van je totaal.", "explanation": "32 − 5 = 27 stickers" }
        ],
        "finalAnswer": "27"
      },
      "conceptId": "tafels_context_tweestaps_stickers",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "context": "Stickers kopen",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee stappen: eerst ×, dan −",
            "content": "Stap 1: Hoeveel stickers in totaal? 4 × 8 = 32. Stap 2: Je geeft er 5 weg: 32 − 5 = 27 stickers over.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Eerst het totaal: 4 × 8 = 32 stickers. Dan trek je de weggegeven stickers af: 32 − 5 = 27 stickers. Bij dit soort opgaven los je het stap voor stap op.",
        "solutionSteps": [
          "Stap 1: 4 × 8 = 32 stickers",
          "Stap 2: 32 − 5 = 27 stickers",
          "Check: 27 stickers over ✓"
        ]
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-004",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "true_false_series",
      "question": "Zijn deze berekeningen juist of onjuist?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Een bakker bakt 6 platen koekjes met 9 koekjes per plaat. Dat zijn 54 koekjes.",
            "isTrue": true,
            "explanation": "6 × 9 = 54. Klopt!"
          },
          {
            "text": "In een klas zitten 5 rijen van 7 stoelen. Dat zijn 30 stoelen.",
            "isTrue": false,
            "explanation": "5 × 7 = 35, niet 30. De leerling rekende waarschijnlijk 5 × 6 = 30."
          },
          {
            "text": "Je spaart 3 weken lang €8 zakgeld. Dan heb je €24.",
            "isTrue": true,
            "explanation": "3 × 8 = 24. Klopt!"
          },
          {
            "text": "Een tuinman plant 8 rijen van 7 bloemen. Dat zijn 54 bloemen.",
            "isTrue": false,
            "explanation": "8 × 7 = 56, niet 54. De leerling verwarde dit waarschijnlijk met 6 × 9 = 54."
          }
        ]
      },
      "conceptId": "tafels_context_tf_controle",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "cognitiveLevel": "comprehension",
      "context": "Controleren van tafelsommen",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Controleer met de tafel",
            "content": "Lees de som goed en reken na. 6 × 9 = 54 ✓. 5 × 7 = 35 (niet 30). 3 × 8 = 24 ✓. 8 × 7 = 56 (niet 54).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Controleer elke berekening door de tafelsom na te rekenen. Let op: 5 × 7 = 35 (niet 30) en 8 × 7 = 56 (niet 54). Foute antwoorden komen vaak doordat je een naburige tafel gebruikt.",
        "solutionSteps": [
          "6 × 9 = 54 → Juist ✓",
          "5 × 7 = 35, niet 30 → Onjuist",
          "3 × 8 = 24 → Juist ✓",
          "8 × 7 = 56, niet 54 → Onjuist"
        ]
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-005",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Je krijgt elke week €7 zakgeld. Na 8 weken wil je een game kopen van €50. Heb je genoeg gespaard?",
      "options": [
        "Ja, je hebt €56 en houdt €6 over",
        "Nee, je hebt maar €49",
        "Ja, je hebt precies €50",
        "Nee, je hebt maar €42"
      ],
      "correctAnswer": 0,
      "conceptId": "tafels_context_zakgeld",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "context": "Zakgeld sparen",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zakgeld × weken",
            "content": "8 weken × €7 = 8 × 7 = €56. De game kost €50. €56 − €50 = €6 over. Dus ja, je hebt genoeg!",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (7×7=49)", "optionIndex": 1 },
          { "id": "rek.partial-calculation", "label": "Vergeet te vergelijken met prijs", "optionIndex": 2 },
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (6×7=42)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "8 weken × €7 = 8 × 7 = €56. De game kost €50. Je hebt €56, dus je houdt €56 − €50 = €6 over. Onthoud: 5-6-7-8 → 7 × 8 = 56!",
        "solutionSteps": [
          "Stap 1: 8 × €7 = €56 gespaard",
          "Stap 2: Vergelijk met de prijs: €56 > €50",
          "Check: €56 − €50 = €6 over ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 8 × 7 = 56 euro. De game kost 50 euro, dus je houdt 6 euro over.",
          "1": "Je dacht waarschijnlijk aan 7 × 7 = 49. Maar je spaart 8 weken, niet 7. 8 × 7 = 56, en dat is genoeg.",
          "2": "Je dacht waarschijnlijk dat 8 × 7 precies 50 is. Maar 8 × 7 = 56, niet 50. Je houdt €6 over.",
          "3": "Je dacht waarschijnlijk aan 6 × 7 = 42. Maar je spaart 8 weken, niet 6. 8 × 7 = 56."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-006",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiplication_grid",
      "question": "Op een schoolreisje gaan 4 klassen. Vul de tabel in: hoeveel kinderen gaan er mee per klas-grootte?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "single_table",
        "baseNumber": 4,
        "range": [6, 7, 8, 9],
        "hiddenCells": [0, 1, 2, 3]
      },
      "conceptId": "tafels_context_grid_schoolreisje",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.68,
      "context": "Schoolreisje",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tafel van 4",
            "content": "Vermenigvuldig elk getal met 4: 6×4=24, 7×4=28, 8×4=32, 9×4=36. Tip: de tafel van 4 is de tafel van 2 verdubbeld!",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Vermenigvuldig het aantal leerlingen per klas met 4 bussen: 6×4=24, 7×4=28, 8×4=32, 9×4=36. Tip: de tafel van 4 is de tafel van 2 verdubbeld!",
        "solutionSteps": [
          "6 × 4 = 24",
          "7 × 4 = 28",
          "8 × 4 = 32",
          "9 × 4 = 36"
        ]
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-007",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Een YouTuber plaatst elke week 3 video's. Na 9 weken wil ze weten hoeveel video's ze heeft geplaatst. Hoeveel zijn dat er?",
      "options": ["12", "21", "27", "36"],
      "correctAnswer": 2,
      "conceptId": "tafels_context_youtube",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "context": "YouTube video's",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Per week × aantal weken",
            "content": "3 video's per week × 9 weken = 9 × 3 = 27 video's. Truc: 9 × 3 = 10 × 3 − 3 = 30 − 3 = 27.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (4×3=12)", "optionIndex": 0 },
          { "id": "rek.multiplication-table-error", "label": "Tafelfout (7×3=21)", "optionIndex": 1 },
          { "id": "rek.operation-confused", "label": "Verwart × met + (9+3) of ander getal", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "9 weken × 3 video's per week = 9 × 3 = 27 video's. Bij 'elke week' vermenigvuldig je het aantal weken met het aantal per week.",
        "solutionSteps": [
          "Stap 1: 9 weken, 3 video's per week",
          "Stap 2: 9 × 3 = 27",
          "Check: 10 × 3 − 3 = 27 ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan 4 × 3 = 12. Maar de YouTuber plaatst 9 weken lang video's, niet 4 weken.",
          "1": "Je dacht waarschijnlijk aan 7 × 3 = 21. Maar het zijn 9 weken, niet 7. 9 × 3 = 27.",
          "2": "Goed! 9 × 3 = 27 video's in totaal.",
          "3": "Je dacht waarschijnlijk aan 9 × 4 = 36. Maar er worden 3 video's per week geplaatst, niet 4. 9 × 3 = 27."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-008",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "step_solver",
      "question": "Je organiseert een verjaardagsfeestje. Je koopt 6 zakjes chips van €2 en 8 flesjes limonade van €1. Hoeveel geef je in totaal uit?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "prompt": "Wat kosten de zakjes chips? (6 × €2)", "correctAnswer": "12", "hint": "Vermenigvuldig het aantal zakjes met de prijs per zakje.", "explanation": "6 × 2 = 12 euro" },
          { "prompt": "Wat kosten de flesjes limonade? (8 × €1)", "correctAnswer": "8", "hint": "Vermenigvuldig het aantal flesjes met de prijs per flesje.", "explanation": "8 × 1 = 8 euro" },
          { "prompt": "Hoeveel geef je in totaal uit? (€12 + €8)", "correctAnswer": "20", "hint": "Tel de kosten van de chips en de limonade bij elkaar op.", "explanation": "12 + 8 = 20 euro" }
        ],
        "finalAnswer": "20"
      },
      "conceptId": "tafels_context_feestje_meerstaps",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "context": "Verjaardagsfeestje",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee producten apart berekenen",
            "content": "Chips: 6 × €2 = €12. Limonade: 8 × €1 = €8. Totaal: €12 + €8 = €20.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Reken elk product apart uit: chips = 6 × €2 = €12, limonade = 8 × €1 = €8. Tel de kosten bij elkaar op: €12 + €8 = €20 in totaal.",
        "solutionSteps": [
          "Stap 1: Chips — 6 × €2 = €12",
          "Stap 2: Limonade — 8 × €1 = €8",
          "Stap 3: Totaal — €12 + €8 = €20",
          "Check: €20 in totaal ✓"
        ]
      }
    }
  ]
}